module.exports = __webpack_public_path__ + "img/up-valencia.12a46cf3.png";